import { ReactNode } from 'react';

import { ComboBoxMenuItem } from './combo-box-menu-item';
import { MenuItem } from '../filter-combo-box/filter-combo-box.types';

export interface ComboBoxMenuProps<T extends MenuItem> {
  data: T[];
  selectedItems: Map<string, T>;
  onToggleItem: (item: T) => void;
  renderListItem?: (item: T) => ReactNode;
  bottomContent?: ReactNode;
}

export const ComboBoxMenu = <T extends MenuItem>(props: ComboBoxMenuProps<T>) => {
  const { data, selectedItems, onToggleItem, renderListItem, bottomContent } = props;

  return (
    <div role="menu" className="popover-menu">
      <div className="popover-menu-content">
        {data.map((item) => {
          return (
            <ComboBoxMenuItem
              key={item.value}
              item={item}
              isSelected={selectedItems.has(item.value)}
              onSelect={onToggleItem}
              renderItem={renderListItem}
            />
          );
        })}
      </div>
      {bottomContent && <div className="popover-menu-bottom-content">{bottomContent}</div>}
    </div>
  );
};
